/**
 * Retorna o primeiro elemento interativo dentro do container.
 * Usar quando for necessário mover o foco programaticamente para um container
 * sem precisar conhecer o tipo exato do elemento-alvo.
 */
export function getFirstFocusableElement(container: HTMLElement): HTMLElement | null {
  return container.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
}
